import { ColumnKey } from '../types/column-key';

export const getColumnKey = <Model>(key: ColumnKey<Model>): string => {
  return key as string;
};
